export default "__VITE_ASSET__Bx_ZjXJw__"